import React, { useEffect } from "react";
import CriarCarteiraMobile from "./criarCarteiraMobile";

const Modal = ({ modalVisivel, setModalVisivel, getCarteiras }) => {
  useEffect(() => {
    if (modalVisivel) {
      // Previne scroll da página atrás do modal
      document.body.style.overflow = "hidden";
      document.body.style.position = "fixed";
      document.body.style.width = "100%";
      document.body.style.height = "100%";
    } else {
      // Restaura scroll normal
      document.body.style.overflow = "unset";
      document.body.style.position = "unset";
      document.body.style.width = "unset";
      document.body.style.height = "unset";
    }
    
    return () => {
      // Cleanup: sempre restaura o scroll ao desmontar
      document.body.style.overflow = "unset";
      document.body.style.position = "unset";
      document.body.style.width = "unset";
      document.body.style.height = "unset";
    };
  }, [modalVisivel]);

  return (
    <>
      {modalVisivel && (
        <div className="fixed top-[-15px] left-0 right-0 bottom-0 w-full h-full bg-blue-600 flex flex-col z-50 overflow-hidden">
          {/* Header com logo */}
          <div className="relative w-full h-32 bg-white rounded-b-full flex-shrink-0">
            <img 
              className="max-w-full h-auto absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2" 
              src={"./logo_unisc.svg"} 
              alt="logo" 
            />
          </div>
          
          {/* Conteúdo principal - ocupa o resto da tela */}
          <div className="flex-1 bg-blue-600 overflow-y-auto">
            <CriarCarteiraMobile
              getCarteiras={getCarteiras}
              setModalVisivel={setModalVisivel}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default Modal;
